import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { PricingSection } from './components/PricingSection';
import { MoreTestimonials } from './components/MoreTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
const HERO_IMAGE_URL = 'https://cdn.magicpatterns.com/uploads/rjs2xbGFdBDcoU5EWHSHKS/ChatGPT_Image_May_19,_2026,_06_45_58_PM.png';
// Inject preload hint for the hero image as soon as the module evaluates,
// so the browser starts downloading it in parallel with the JS bundle.
if (typeof document !== 'undefined') {
  const existing = document.head.querySelector(`link[rel="preload"][href="${HERO_IMAGE_URL}"]`);
  if (!existing) {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = HERO_IMAGE_URL;
    (link as any).fetchPriority = 'high';
    document.head.appendChild(link);
  }
}
export function App() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    // Defer the Meta Pixel until the browser is idle so it doesn't compete
    // with the initial paint and hero image load.
    const loadPixel = () => {
      const PIXEL_ID = '1289554852658050';
      const w = window as any;
      if (w.fbq) {
        w.fbq('track', 'PageView');
        return;
      }
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      w.fbq('init', PIXEL_ID);
      w.fbq('track', 'PageView');
    };
    const w = window as any;
    if (typeof w.requestIdleCallback === 'function') {
      const id = w.requestIdleCallback(loadPixel, {
        timeout: 3000
      });
      return () => w.cancelIdleCallback && w.cancelIdleCallback(id);
    }
    const t = setTimeout(loadPixel, 1500);
    return () => clearTimeout(t);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past the hero section
      if (window.scrollY > 600) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-primary/20 selection:text-primary" data-id="element-0">
      <HeroSection data-id="element-1" />
      <SocialProof data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ProductBreakdown data-id="element-5" />
      <BonusSection data-id="element-6" />
      <UrgencySection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <MoreTestimonials data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <CostComparison data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />

      {/* Purchase notifications popup */}
      <PurchaseNotification data-id="element-15" />

      {/* Mobile Sticky CTA */}
      <div className={`fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] transform transition-transform duration-300 z-50 md:hidden ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-16">
        <a href="#pricing" className="flex items-center justify-center w-full py-3 px-4 bg-gradient-to-r from-primary to-secondary text-white font-bold rounded-xl shadow-lg" data-id="element-17">
          QUIERO MI MEGAPACK
        </a>
      </div>
    </div>;
}